import React, { useState, useEffect } from "react";
import _ from "lodash";
import Alert from "../shared/common/alert";
import { compose } from "redux";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import * as loaderAction from "../../redux/loader/action";
import * as paramsAction from "../../redux/gameParams/actions";
import Socket from "../../socket/socket";
import { button_bg } from "../../assets/images/fluster";
import { start_game } from "../../assets/images/fluster";

const FlusterLobbyFooter = (props) => {
  const [rounds, setRounds] = useState(5);
  const [timer, settimer] = useState(60);

  const parameters = _.get(props, "paramsReducer.gameObj.screens");
  const roomData = _.get(props, "gameReducer.roomObj");
  const users = _.get(roomData, "users");
  const gameName = _.get(props, "gameReducer.gameName");
  const status = _.get(roomData, "game_state.status");
  const { onBack } = props;
  const game_options = _.get(
    parameters,
    "_joining.game_options",
    "Game options"
  );
  const roundss = _.get(parameters, "_joining.rounds", "Rounds");
  const timr = _.get(parameters, "_joining.timer", "Timer");
  let timerForMapp = roomData.lobby_parameters.timer;
  const start_games = _.get(parameters, "_joining.start_game", "START GAME");
  const back = _.get(parameters, "_joining.back", "BACK");
  let scoreToWin = roomData.lobby_parameters.score_to_win;

  useEffect(() => {
    return Socket.addListener("update-status", () => {
      props.setIsLoading(false);
      props.history.push("/fluster");
    });
  }, []);

  useEffect(() => {
    if (status != "Joining") {
      let gameObj = props.gameReducer;
      let dataObj = {
        gameName:
          gameObj.gameName !== "" ? gameObj.gameName : gameObj.roomObj.game_code
      };
      props.getGameData(dataObj);
      if (Object.keys(props.paramsReducer.gameObj).length > 0) {
        props.history.push("/fluster");
      }
    }
  }, [status, props.paramsReducer.gameObj]);

  const onStartGame = () => {
    if (users && users.length < 2) {
      Alert(400, "Need at least 2 players to start the game");
      return;
    } else {
      props.setIsLoading(true);
      let data = {
        action: "update-status",
        roomId: roomData.id,
        tableTopName: "Fluster",
        rounds,
        timer
      };
      Socket.sendMessage(data);
    }
  };
  useEffect(() => {
    let data = {
      action: "update-lobby-options",
      roomId: roomData.id,
      timer: timer
    };
    Socket.sendMessage(data);
  }, [timer]);

  useEffect(() => {
    let data = {
      action: "update-lobby-options",
      roomId: roomData.id,
      score_to_win: rounds
    };
    Socket.sendMessage(data);
  }, [rounds]);

  const onAddOrSubtractRounds = (key) => {
    if ((rounds > 19 && key == 1) || (rounds == 2 && key === -1)) {
      return;
    } else {
      setRounds(rounds + key);
    }
  };

  const onAddOrSubtractTimer = (key) => {
    if ((timer === 120 && key == 30) || (timer == 30 && key === -30)) {
      return;
    } else {
      settimer(timer + key);
    }
  };

  return (
    <>
      <div className="footer">
        <h3 className="heading">{game_options}</h3>
        <div className="content">
          <div className="buttons-section">
            <h4>{roundss}</h4>
            <div className="buttons">
              <img src={button_bg} alt="" />
              <div className="button_postion">
                <button
                  type="button"
                  className="btn"
                  onClick={() => onAddOrSubtractRounds(1)}
                >
                  <i className="fal fa-angle-up"></i>
                </button>
                <button
                  type="button"
                  className="btn"
                  onClick={() => onAddOrSubtractRounds(-1)}
                >
                  <i className="fal fa-angle-down"></i>
                </button>
              </div>
              <h5>{scoreToWin}</h5>
            </div>
          </div>
          <div className="buttons-section">
            <h4>{timr}</h4>
            <div className="buttons">
              <img src={button_bg} alt="" />
              <div className="button_postion">
                <button
                  type="button"
                  className="btn"
                  onClick={() => onAddOrSubtractTimer(+30)}
                >
                  <i className="fal fa-angle-up"></i>
                </button>
                <button
                  type="button"
                  className="btn"
                  onClick={() => onAddOrSubtractTimer(-30)}
                >
                  <i className="fal fa-angle-down"></i>
                </button>
              </div>
              <h5 className="seconds">{timerForMapp}</h5>
            </div>
          </div>
          <div className="start-game" onClick={onStartGame}>
            <img src={start_game} alt="" />
            <h3>{start_games}</h3>
          </div>
        </div>
      </div>
      <div className="back-btn" onClick={onBack}>
        <img src={start_game} alt="" />
        <h3>{back}</h3>
      </div>
    </>
  );
};

const mapStateToProps = (state) => ({
  gameReducer: state.gameReducer,
  paramsReducer: state.paramsReducer
});
const mapDispatchToProps = (dispatch) => {
  return {
    setIsLoading: (data) => dispatch(loaderAction.setIsLoading(data)),
    getGameData: (data) => dispatch(paramsAction.getGameData(data))
  };
};

export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(FlusterLobbyFooter);
